import { useState } from 'react';
import { IconButton } from '../';
import {
  StyledFirstBattle,
  FirstBattleText,
  FirstBattleBroadsideLogo,
  FirstBattleModeLogo
} from './FirstBattle.styled';

const FirstBattle = ({ onBattleStart, hasControls = true }) => {
  const [buttonClicked, setButtonClicked] = useState(false);

  const clickHandler = () => {
    setButtonClicked(true)
    if (!buttonClicked) {
      onBattleStart();
    }
  }
  return (
    <StyledFirstBattle $withpadding={hasControls}>
      <FirstBattleText>
        Welcome To
      </FirstBattleText>
      <FirstBattleBroadsideLogo src='/assets/bslogotrans.png'/>
      <FirstBattleModeLogo src='/assets/battle_mode.png'/>
      {hasControls && <IconButton onClick={clickHandler} disabled={buttonClicked}>
        {buttonClicked ? 'Loading...' : 'Battle Now'}
      </IconButton>}
    </StyledFirstBattle>
  );
}

export default FirstBattle;
